// 모든 쿠키 삭제 함수
export const clearAllCookies = () => {
  // 현재 도메인의 모든 쿠키 가져오기
  const cookies = document.cookie.split(";");
  // 각 쿠키를 만료시켜 삭제
  cookies.forEach((cookie) => {
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

    if (name) {
      // 현재 도메인과 경로에서 삭제
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;

      // 루트 도메인 삭제 (서브도메인 대응)
      const domain = window.location.hostname;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;

      // 상위 도메인 삭제
      const domainParts = domain.split(".");
      if (domainParts.length > 2) {
        const rootDomain = "." + domainParts.slice(-2).join(".");
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${rootDomain}`;
      }
    }
  });
};

// 로그아웃 시에도 보존할 localStorage 키 목록
const PRESERVE_KEYS = ["gtpa_dismissed_version"];

// 세션 스토리지, 로컬 스토리지 초기화
export const clearBrowserStorage = () => {
  try {
    // 보존할 값 백업
    const preserved = PRESERVE_KEYS.reduce<Record<string, string | null>>(
      (acc, key) => {
        acc[key] = localStorage.getItem(key);
        return acc;
      },
      {}
    );

    localStorage.clear();
    sessionStorage.clear();

    // 보존할 값 복원
    for (const [key, value] of Object.entries(preserved)) {
      if (value !== null) {
        localStorage.setItem(key, value);
      }
    }
  } catch (error) {
    console.error("브라우저 스토리지 초기화 실패:", error);
  }
};

// 로그아웃 이벤트 다른 탭에 브로드캐스트 (다른 브라우저 탭에서 로그아웃 이벤트 감지 및 자동 로그아웃)
export const broadcastLogout = () => {
  try {
    localStorage.setItem("logout_event", Date.now().toString());
    localStorage.removeItem("logout_event");
  } catch (error) {
    console.error("로그아웃 브로드캐스트 실패:", error);
  }
};
